export function initGlobalNav() {
  const nav = document.querySelector('nav.globalNav');
  if (!nav) return;

  const btn = document.querySelector('button.menuBtn') || nav.querySelector('button.menuBtn');
  const list = nav.querySelector('ul.globalNav-list');
  if (!btn || !list) return;

  function onKeyDown(e) {
    if (e.key === 'Escape') close();
  }

  function open() {
    nav.classList.add('is-open');
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    list.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    document.addEventListener('keydown', onKeyDown);
  }

  function close() {
    nav.classList.remove('is-open');
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    list.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    document.removeEventListener('keydown', onKeyDown);
  }

  function toggle() {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) close(); else open();
  }

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    toggle();
  });

  // Close when clicking a link inside the nav
  list.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => close());
  });

  // Close when clicking on the backdrop (.globalNav-wrapper)
  const wrapper = nav.querySelector('.globalNav-wrapper');
  if (wrapper) {
    wrapper.addEventListener('click', (e) => {
      if (e.target === wrapper) close();
    });
  }

  // Initialize state
  if (!list.hasAttribute('aria-hidden')) list.setAttribute('aria-hidden', 'true');
  btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
}
